<script>
/* eslint-disable semi */
import { Component } from 'vue-property-decorator';
import AppButton from './AppButton';

@Component({})
export default class AppButtonBack extends AppButton {
  created () {
    const resourceCode = 'common.button.back';
    this.buttonText = this.label === '' ? this.$t(resourceCode) : this.label;
  }

  onClick () {
    this.$router.back();
  }
}
</script>



// WEBPACK FOOTER //
// src/app/parts/button/AppButtonBack.vue